<script setup lang="ts">
import type { Board } from "@/model/board";

import LinkLayer from "./internal/LinkLayer.vue";

defineProps<{ board: Board; color: string }>();
</script>

<template>
  <LinkLayer :board :color />
  <LinkLayer :board :color priority />
</template>
